import { MenuItem, OutlinedInput, Select, Typography } from "@mui/material";
import { useAppSelector } from "hooks/StoreHooks";
import { useState } from "react";
import { useSearchParams } from "react-router";
import { selectLocations } from "store/Selectors/locationsSelector";
import { Location } from "store/Slices/locationSlice";

import { PARAM_KEY } from "constants/navigation";
import { UNAVAILABLE_WAREHOUSE } from "pages/Home/Home";
import "./WarehouseSelectionHeader.scss";

type Props = {
  onWarehouseChange: (warehouse: Location) => void;
  warehouse: Location;
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 7;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function WarehouseSelectionCombo({
  onWarehouseChange,
  warehouse,
}: Props) {
  const locations = useAppSelector(selectLocations);
  const [selectedLocation, setSelectedLocation] = useState<Location>(
    warehouse ? warehouse : UNAVAILABLE_WAREHOUSE
  );
  const [_, setSearchParams] = useSearchParams();
  const handleWarehouseChange = (locationName: string) => {
    const associatedLocation = locations.find(
      location => location.name == locationName
    );
    setSelectedLocation(associatedLocation!);
    onWarehouseChange(associatedLocation!);
  };

  return (
    <div className="warehouse-header-zone">
      <Typography component="h2" className="header-warehouse-name">
        {"Entrepôt - " + selectedLocation.name}
      </Typography>

      <div className="warehouse-select-zone">
        <Typography className="header-select">
          Sélectionner un entrepôt
        </Typography>
        <Select
          displayEmpty
          value={selectedLocation.name}
          onChange={e => handleWarehouseChange(e.target.value)}
          input={<OutlinedInput />}
          MenuProps={MenuProps}
          className="drop-down-warehouse-selection"
          style={{
            paddingTop: "0px !important",
            paddingBottom: "0px !important",
          }}>
          {locations.map(location => (
            <MenuItem
              key={location.storeNb}
              onClick={() =>
                setSearchParams({
                  [PARAM_KEY.WAREHOUSE]: location.storeNb.toString(),
                })
              }
              value={location.name}>
              {location.name}
            </MenuItem>
          ))}
        </Select>
      </div>
    </div>
  );
}
